import {
  getHolidays as getHolidaysService,
  createHoliday as createHolidayService,
  updateHoliday as updateHolidayService,
  deleteHoliday as deleteHolidayService,
} from "services/company/leaveManagement/holiday/holidayService";
import {
  getHolidaysStart,
  getHolidaysSuccess,
  getHolidaysFailure,
  createHolidayStart,
  createHolidaySuccess,
  createHolidayFailure,
  updateHolidayStart,
  updateHolidaySuccess,
  updateHolidayFailure,
  deleteHolidayStart,
  deleteHolidaySuccess,
  deleteHolidayFailure,
} from "./holidaySlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all holidays
export const fetchHolidays = () => async (dispatch) => {
  try {
    dispatch(getHolidaysStart());
    const response = await getHolidaysService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getHolidaysSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch holidays";
      dispatch(getHolidaysFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch holidays error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch holidays";
    dispatch(getHolidaysFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new holiday
export const createNewHoliday = (holidayData) => async (dispatch) => {
  try {
    dispatch(createHolidayStart());
    const response = await createHolidayService(holidayData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createHolidaySuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Holiday created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create holiday";
      dispatch(createHolidayFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create holiday error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create holiday";
    dispatch(createHolidayFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update a holiday
export const updateExistingHoliday =
  (holidayId, holidayData) => async (dispatch) => {
    try {
      dispatch(updateHolidayStart());
      const response = await updateHolidayService(holidayId, holidayData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateHolidaySuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Holiday updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg = response?.meta?.message || "Failed to update holiday";
        dispatch(updateHolidayFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update holiday error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update holiday";
      dispatch(updateHolidayFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Delete a holiday
export const deleteExistingHoliday = (holidayId) => async (dispatch) => {
  try {
    dispatch(deleteHolidayStart());
    const response = await deleteHolidayService(holidayId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(deleteHolidaySuccess(holidayId));
      showSuccessToast(
        response?.meta?.message || "Holiday deleted successfully!",
      );
      return { success: true };
    } else {
      const errorMsg = response?.meta?.message || "Failed to deleted holiday";
      dispatch(deleteHolidayFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Delete holiday error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to delete holiday";
    dispatch(deleteHolidayFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
